/**
 * Touch layout helpers. Desktop (990px and a fine pointer) is left to the existing scripts.
 */
(function () {
  var compact = window.matchMedia('(max-width: 989px)');

  function measureHeader() {
    var cluster = document.querySelector('.ri-header__sticky-cluster');
    var header = document.querySelector('.section-header');
    var node = compact.matches && cluster ? cluster : header;
    if (!node) return;
    var rect = node.getBoundingClientRect();
    var height = Math.ceil(rect.height);
    var bottom = Math.ceil(rect.bottom);
    document.documentElement.style.setProperty('--ri-header-sticky-h', height + 'px');
    if (compact.matches) {
      document.documentElement.style.setProperty('--header-height', height + 'px');
      document.documentElement.style.setProperty('--header-bottom-position', bottom + 'px');
    }
  }

  compact.addEventListener('change', function () {
    measureHeader();
    var root = document.documentElement;
    if (!compact.matches && root._riSearchLocked && window.RIScrollLock) {
      window.RIScrollLock.unlock();
      root._riSearchLocked = false;
    }
  });
  window.addEventListener('resize', measureHeader);
  function bootHeader() {
    measureHeader();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootHeader);
  } else {
    bootHeader();
  }
  window.addEventListener('load', measureHeader);

  document.addEventListener('change', function (event) {
    var select = event.target.closest('[data-ri-compact-sort]');
    if (!select) return;
    var native = document.getElementById('SortBy-mobile');
    if (!native) return;
    native.value = select.value;
    native.dispatchEvent(new Event('input', { bubbles: true }));
    native.dispatchEvent(new Event('change', { bubbles: true }));
  });

  document.addEventListener('ri:grid-replaced', function () {
    document.querySelectorAll('body > ri-choose-options.is-sheet').forEach(function (sheet) {
      if (typeof sheet.close === 'function') sheet.close();
      if (sheet.parentElement === document.body) sheet.remove();
    });
  });
})();
